<template>
  <div class="calendar-wrapper">
    <!-- Header -->
    <div class="calendar-header">
      <div class="time-header rounded"></div>
      <div
          v-for="staff in staffList"
          :key="staff.id"
          class="staff-header"
      >
        <img :src="staff.image" class="rounded-circle" style="width: 45px;height: 45px"/>
        <div>

          {{ staff.name }}
        </div>
      </div>
    </div>

    <!-- Body -->
    <div class="calendar-body">
      <!-- Time column -->
      <div class="time-column">
        <div
            v-for="time in timeSlots"
            :key="time"
            class="time-slot"
        >
          {{ time }}
        </div>
      </div>

      <!-- Staff columns -->
      <div
          v-for="staff in staffList"
          :key="staff.id"
          class="staff-column"
      >
        <div
            v-for="booking in staffBookings(staff.id)"
            :key="booking.id"
            class="booking"
            :style="bookingStyle(booking)"
        >
          <strong>{{ booking.title }}</strong>
          <div class="small">
            {{ booking.start }} - {{ booking.end }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'BookingCalendar',
props:{
  reservations:{
    type:Array,
    default: () => []
  }
},
  data() {
    return {
      startHour: 10,
      endHour: 18,
      pxPerMinute: 1,

      staffList: [

      ],

      bookings: [
        {
          id: 1,
          staff_id: 1,
          title: 'Haircut',
          start: '09:30',
          end: '10:30'
        },
        {
          id: 2,
          staff_id: 2,
          title: 'Beard',
          start: '10:00',
          end: '11:00'
        },
        {
          id: 3,
          staff_id: 3,
          title: 'Color',
          start: '11:15',
          end: '12:45'
        }
      ]
    }
  },
  mounted() {
    this.get_admins();
  },

  computed: {
    timeSlots() {
      const slots = []
      for (let h = this.startHour; h <= this.endHour; h++) {
        slots.push(`${h.toString().padStart(2, '0')}:00`)
      }
      return slots
    }
  },
watch:{
  'reservations':function (){
   this.convert_to_chart()
  }


},
  methods: {
    staffBookings(staffId) {
      return this.bookings.filter(b => b.staff_id === staffId)
    },
    convert_to_chart(){
      this.bookings = []
      var self = this
       this.startHour= 10
          this.endHour= 18;
      this.reservations.filter(x=>x.status==1).forEach(function (val){
        // if(val.reserve_time.date.split(" ")[1].substring(0,5))
        if(val.reserve_time.date.split(" ")[1].substring(0,2)>self.endHour){
          while(self.endHour<val.reserve_time.date.split(" ")[1].substring(0,2)){
            self.endHour++;
          }
        }if(val.reserve_time.date.split(" ")[1].substring(0,2)<self.startHour){
          while(self.startHour>val.reserve_time.date.split(" ")[1].substring(0,2)){
            self.startHour--;
          }
        }
        self.bookings.push(

            {
              id: val.id,
              staff_id: val.admin.id,
              title: val.line.title,
              start: val.reserve_time.date.split(" ")[1].substring(0,5),
              end: val.reserve_time.end_date.split(" ")[1].substring(0,5)
            },
        )
      })
    },
    get_admins() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);
      var formData = new FormData();
      axios.post('/api/admin/user/get_admin', formData, {}).then(function (response) {

        self.staffList =response.data
self.convert_to_chart();
      })
          .catch(function (error) {

            console.log(error);
          });

    },

    bookingStyle(booking) {
      const start = this.toMinutes(booking.start)
      const end = this.toMinutes(booking.end)

      return {
        top: (start - this.startHour * 60) * this.pxPerMinute + 'px',
        height: (end - start) * this.pxPerMinute + 'px'
      }
    },

    toMinutes(time) {
      const [h, m] = time.split(':')
      return (+h * 60) + +m
    }
  }
}
</script>

<style scoped>
.calendar-wrapper {
  border: 1px solid #ddd;
  overflow-x: auto;
}

.calendar-header {
  display: grid;
  grid-template-columns: 60px repeat(3, 1fr);
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.time-header {
  border-right: 1px solid #ddd;
  border-left: 1px solid #ddd;
}

.staff-header {
  padding: 10px;
  text-align: center;
  font-weight: bold;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
}

.calendar-body {
  display: grid;
  grid-template-columns: 60px repeat(3, 1fr);
  height: fit-content;
  overflow-y: auto;
}

.time-column {
  border-right: 1px solid #ddd;
  border-left: 1px solid #ddd;
}

.time-slot {
  height: 60px;
  font-size: 12px;
  padding: 4px;
  color: #666;
  border-bottom: 1px solid #eee;
}

.staff-column {
  position: relative;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
}

.booking {
  position: absolute;
  left: 6px;
  right: 6px;
  background: rgba(81, 204, 138, 0.22);
  border-left: 3px solid #51cc8a;;
  color: black;
  border-radius: 6px;
  padding: 6px;
  font-size: 12px;
  box-sizing: border-box;
}

.booking .small {
  font-size: 10px;
  opacity: 0.9;
}
</style>
